/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FallbackImage, Icon, Modal, Pagination, Table } from 'components';
import { DashboardService } from "services";
import { Globals } from "utils";
import moment from "moment";
import { WhiteImage } from "assets/img";
import ModalCreatePlan from "./plans/modal-create-plan";

const Home = () => {
	const [selectedItem, setSelectedItem] = useState();
	const { currentMonth, data, load } = useFetch();

	return (
		<div id="admin-dashboard">
			<Modal
				className="modal-create-plan"
				visible={selectedItem}
				withoutClose={true}
				onClose={() => setSelectedItem(undefined)}
			>
				<ModalCreatePlan
					item={selectedItem}
					onClose={() => setSelectedItem(undefined)}
					onSubmit={() => {
						load();
						setSelectedItem(undefined);
					}}
				/>
			</Modal>

			<main>
				<section className="cards-1">
					<p className="title">Planes de Membresía</p>
					<p className="subtitle">Planes de Membresía</p>
					<div className="plans">
						{data?.plans?.map((item: any, index: number) => (
							<div key={index} className="_card">
								<div className="first">
									<div className="plan-img-wrapper">
										<FallbackImage
											src={item.icon}
											placeholder={WhiteImage}
											className="plan-img"
											placeholderClassName="plan-img-placeholder"
											alt={item.name}
										/>
									</div>
									<div>
										<p className="plan-name">{ item.name }</p>
										<p className="plan-annual">Tarifa anual</p>
										<p className="plan-annual-price">{ Globals.formatMiles(item.amount, true) }</p>
									</div>
								</div>
								<div className="plan-freq">
									<p>Tarifa semestral</p>
									<p>{ Globals.formatMiles(item.semestral_amount, true) }</p>
								</div>
								<div className="plan-freq">
									<p>Tarifa trimestral</p>
									<p>{ Globals.formatMiles(item.trimestral_amount, true) }</p>
								</div>
								<div className="plan-freq">
									<p>Tarifa mensual</p>
									<p>{ Globals.formatMiles(item.mensual_amount, true) }</p>
								</div>
								<div className="plan-actions">
									<button onClick={() => setSelectedItem(item)}>
										<Icon name="edit" />
									</button>
								</div>
							</div>
						))}
					</div>
				</section>

				<section className="cards-2">
					<div className="first">
						<p className="title">Ingresos{'\n'}Totales</p>
						<p className="subtitle">{ currentMonth }</p>
					</div>

					<div className="amount">
						<p><span>$ </span>{ Globals.formatMiles(data.incomes.total_income, true, '') }</p>
					</div>
				</section>

				<div className="cards-3">
					<div className="_card">
						<p className="title">Ingresos por afiliaciones</p>
						<span className="chip yellow">{ currentMonth }</span>
						<p className="amount"><span>Total</span> { Globals.formatMiles(data.incomes.income_affiliations, true) }</p>
					</div>
					<div className="_card">
						<p className="title">Ingresos por teleconsultas</p>
						<span className="chip green">{ currentMonth }</span>
						<p className="amount"><span>Total</span> { Globals.formatMiles(data.incomes.income_teleconsultations, true) }</p>
					</div>
					<div className="_card">
						<p className="title">Ingresos por publicidad</p>
						<span className="chip yellow-light">{ currentMonth }</span>
						<p className="amount"><span>Total</span> { Globals.formatMiles(data.incomes.income_advertising, true) }</p>
					</div>
				</div>
			</main>

			<main>
				<div className="cards-4">
					<div className="first">
						<p className="title">Número de{'\n'}afiliaciones</p>
						<p className="subtitle">{ currentMonth }</p>
					</div>
					<div className="amount">
						<label>Total</label>
						<p>{ data.total_affiliations }</p>
					</div>
				</div>

				<div className="cards-5">
					<Table
						title="Usuarios Registrados"
						header={['Nombre','Fecha de nacimiento','Edad','Estado','Animales']}
						data={5}
					>
						{data?.clients?.map((item: any, index: number) => {
							const animals: string[] = [];
							if (item.animals) {
								item.animals.forEach((x: any) => {
									x.animals.forEach((y: any) => {
										animals.push(y.name);
									});
								});
							}

							return (
								<tr key={index}>
									<td>{ item.name }</td>
									<td>{ item.birthdate ? moment(item.birthdate).format('DD/MM/YYYY') : '-' }</td>
									<td>{ item.age || '-' }</td>
									<td>{ item.state }</td>
									<td>{ animals?.join(', ') || '-' }</td>
								</tr>
							)
						})}
					</Table>

					{/* <Pagination
						pages={2}
						active={1}
						onChange={async (page: number) => {}}
					/> */}
				</div>
			</main>
		</div>
	)
}

const useFetch = () => {
	const dispatch = useDispatch();
	const [currentMonth] = useState(moment().format('MMMM'));
	const [data, setData] = useState({
		plans: [],
		clients: [],
		total_affiliations: 0,
		incomes: {
			total_income: 0,
			income_affiliations: 0,
			income_teleconsultations: 0,
			income_advertising: 0
		},
	});

	const fetchData = async () => {
		try {
			const res: any = await DashboardService.admin.get();
			setData({
				plans: res.plans,
				clients: res.clients?.rows,
				total_affiliations: res.total_affiliations,
				incomes: res.incomes,
			});

		} catch (error) {
			console.log(error)
		}
	}

	useEffect(() => {
		dispatch({ type: 'SET_HEADER', payload: { title: 'Inicio', onBack: null } });
		fetchData();
	}, []);

	return {
		currentMonth,
		data,
		load: fetchData,
	}
}

export default Home;